import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { translateTag } from "@/utils/tagTranslations";

export const CityBlogSection = ({ citySlug, lang = "ru" }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await fetch(`/api/blog/posts?city=${citySlug}&limit=4`);
        const data = await res.json();
        setArticles(data.articles || []);
      } catch {
        // silently fail
      }
    };
    if (citySlug) fetchArticles();
  }, [citySlug]);

  if (articles.length === 0) return null;

  const titleMain = lang === "tr" ? "Faydalı makaleler" : (lang === "en" ? "Useful articles" : "Полезные статьи");
  const readMore = lang === "tr" ? "Oku" : (lang === "en" ? "Read" : "Читать");
  const allArticles = lang === "tr" ? "Tüm makaleler" : (lang === "en" ? "All articles" : "Все статьи");

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white to-gray-50" data-testid="city-blog-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between mb-6 sm:mb-8">
          <h2
            className="text-2xl sm:text-3xl font-bold text-gray-900"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            <BookOpen className="w-6 h-6 text-pink-500 inline-block mr-2 -mt-1" />
            {titleMain}
          </h2>
          <Link
            to="/blog"
            className="text-sm font-medium text-pink-500 hover:text-pink-600 flex items-center gap-1 transition-colors"
            data-testid="blog-see-all"
          >
            {allArticles} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {articles.map((article) => {
                const title = lang === "tr" && article.title_tr ? article.title_tr : (lang === "en" && article.title_en ? article.title_en : article.title_ru);
                const excerpt = lang === "tr" && article.excerpt_tr ? article.excerpt_tr : (lang === "en" && article.excerpt_en ? article.excerpt_en : article.excerpt_ru);
            return (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className="group block p-4 sm:p-5 rounded-2xl border border-gray-100 hover:border-pink-200 hover:shadow-lg transition-all bg-white"
                data-testid={`blog-card-${article.slug}`}
              >
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {(article.tags || []).slice(0, 2).map((tag) => (
                    <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-pink-50 text-pink-600 font-medium">
                      {translateTag(tag, lang)}
                    </span>
                  ))}
                </div>
                <h3 className="text-sm font-bold text-gray-900 mb-2 group-hover:text-pink-600 transition-colors line-clamp-2">
                  {title}
                </h3>
                <p className="text-xs text-gray-500 line-clamp-2 mb-3">{excerpt}</p>
                <span className="text-xs font-semibold text-pink-500 group-hover:text-pink-600 flex items-center gap-1">
                  {readMore} <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CityBlogSection;
